import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

export const AWSStatusDisplay = {
  CREATE_IN_PROGRESS: "Creating...",
  CREATE_FAILED: "Create Failed",
  CREATE_COMPLETE: "Running",
  UPDATE_IN_PROGRESS: "Updating...",
  UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: "Updating...",
  UPDATE_FAILED: "Update Failed",
  UPDATE_COMPLETE: "Running",
  UPDATE_ROLLBACK_FAILED: "Update Rollback Failed",
  UPDATE_ROLLBACK_IN_PROGRESS: "Update Rolling Back...",
  UPDATE_ROLLBACK_COMPLETE: "Update Rollback Completed",
  UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: "Update Rolling Back...",
  ROLLBACK_IN_PROGRESS: "Rolling Back...",
  ROLLBACK_FAILED: "Rollback Failed",
  ROLLBACK_COMPLETE: "Rollback Completed",
  DELETE_IN_PROGRESS: "Shutting Down...",
  DELETE_FAILED: "Shutdown Failed",
};

export function getStatusIconColor(workflowStatus) {
  switch (workflowStatus) {
    case AWSStatusRaw.CREATE_COMPLETE:
    case AWSStatusRaw.UPDATE_COMPLETE:
      return "primary";
    case AWSStatusRaw.CREATE_IN_PROGRESS:
    case AWSStatusRaw.UPDATE_IN_PROGRESS:
    case AWSStatusRaw.UPDATE_COMPLETE_CLEANUP_IN_PROGRESS:
      return "secondary";
    case AWSStatusRaw.ROLLBACK_IN_PROGRESS:
    case AWSStatusRaw.ROLLBACK_COMPLETE:
    case AWSStatusRaw.UPDATE_ROLLBACK_COMPLETE:
      return "warning";
    case AWSStatusRaw.DELETE_IN_PROGRESS:
      return "disabled";
    default:
      return "error";
  }
}

interface css {
  flash: string;
}

export function getWorkflowMainIcon(workflowStatus: string, classes: css, syncKey: string) {
  const iconColor = getStatusIconColor(workflowStatus);
  const iconStyles = { width: "3.5em", height: "3.5em", marginRight: "1.3em" };

  switch (workflowStatus) {
    case AWSStatusRaw.CREATE_COMPLETE:
    case AWSStatusRaw.UPDATE_COMPLETE:
      return <CloudDoneIcon color={iconColor} sx={iconStyles} />;
    case AWSStatusRaw.CREATE_IN_PROGRESS:
    case AWSStatusRaw.UPDATE_IN_PROGRESS:
    case AWSStatusRaw.UPDATE_COMPLETE_CLEANUP_IN_PROGRESS:
    case AWSStatusRaw.ROLLBACK_IN_PROGRESS:
    case AWSStatusRaw.UPDATE_ROLLBACK_IN_PROGRESS:
    case AWSStatusRaw.UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS:
      return <CloudQueueIcon color={iconColor} sx={iconStyles} className={classes.flash} key={syncKey} />;
    case AWSStatusRaw.CREATE_FAILED:
    case AWSStatusRaw.UPDATE_FAILED:
    case AWSStatusRaw.UPDATE_ROLLBACK_FAILED:
    case AWSStatusRaw.ROLLBACK_FAILED:
    case AWSStatusRaw.DELETE_FAILED:
    case AWSStatusRaw.ROLLBACK_COMPLETE:
    case AWSStatusRaw.UPDATE_ROLLBACK_COMPLETE:
      return <CloudOffIcon color={iconColor} sx={iconStyles} />;
    case AWSStatusRaw.DELETE_IN_PROGRESS:
      return <RemoveCircleOutlineIcon color={iconColor} sx={iconStyles} className={classes.flash} key={syncKey} />;
    default:
      return <QuestionMarkIcon color={"error"} sx={iconStyles} />;
  }
}

export const AWSStatusRaw = {
  CREATE_IN_PROGRESS: "CREATE_IN_PROGRESS",
  CREATE_FAILED: "CREATE_FAILED",
  CREATE_COMPLETE: "CREATE_COMPLETE",
  UPDATE_IN_PROGRESS: "UPDATE_IN_PROGRESS",
  UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: "UPDATE_COMPLETE_CLEANUP_IN_PROGRESS",
  UPDATE_FAILED: "UPDATE_FAILED",
  UPDATE_ROLLBACK_FAILED: "UPDATE_ROLLBACK_FAILED",
  UPDATE_ROLLBACK_IN_PROGRESS: "UPDATE_ROLLBACK_IN_PROGRESS",
  UPDATE_ROLLBACK_COMPLETE: "UPDATE_ROLLBACK_COMPLETE",
  UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: "UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS",
  UPDATE_COMPLETE: "UPDATE_COMPLETE",
  ROLLBACK_IN_PROGRESS: "ROLLBACK_IN_PROGRESS",
  ROLLBACK_FAILED: "ROLLBACK_FAILED",
  ROLLBACK_COMPLETE: "ROLLBACK_COMPLETE",
  DELETE_IN_PROGRESS: "DELETE_IN_PROGRESS",
  DELETE_FAILED: "DELETE_FAILED",
};

export const IsInSuccessState = (status: string): boolean => {
  return status === AWSStatusRaw.CREATE_COMPLETE || status === AWSStatusRaw.UPDATE_COMPLETE;
};
